import React, { useState } from 'react';
import { FiCreditCard, FiArrowUp, FiArrowDown } from 'react-icons/fi';
import { MdAccountBalance } from 'react-icons/md';
import './Payments.css';

const Payments = () => {
  const [activeTab, setActiveTab] = useState('send');
  const [amount, setAmount] = useState('');
  const [recipient, setRecipient] = useState('');

  const transactions = [
    { id: 1, type: 'sent', name: 'John Doe', date: 'Today at 2:30 PM', amount: 150.00 },
    { id: 2, type: 'received', name: 'Jane Smith', date: 'Yesterday at 5:45 PM', amount: 250.00 },
    { id: 3, type: 'sent', name: 'Electricity Bill', date: 'Oct 12, 2023', amount: 85.50 },
    { id: 4, type: 'received', name: 'Freelance Payment', date: 'Oct 5, 2023', amount: 1200.00 }
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Payment processed successfully!');
  };

  return (
    <div className="payments-container">
      <div className="payments-header">
        <h1>Payments</h1>
        <p>Send and receive money securely</p>
      </div>

      <div className="tabs">
        <button 
          className={activeTab === 'send' ? 'tab-btn active' : 'tab-btn'} 
          onClick={() => setActiveTab('send')}
        >
          Send Money
        </button>
        <button 
          className={activeTab === 'request' ? 'tab-btn active' : 'tab-btn'} 
          onClick={() => setActiveTab('request')}
        >
          Request Money
        </button>
        <button 
          className={activeTab === 'history' ? 'tab-btn active' : 'tab-btn'} 
          onClick={() => setActiveTab('history')}
        >
          History
        </button>
      </div>

      <div className="tab-content">
        {activeTab === 'send' && (
          <div className="payment-card">
            <h2>Send Money</h2>
            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <label>Amount</label>
                <div className="amount-input">
                  <span className="currency">$</span>
                  <input
                    type="number"
                    placeholder="0.00"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="input-group">
                <label>Recipient</label>
                <input
                  type="text"
                  placeholder="Email, phone number, or account ID"
                  value={recipient}
                  onChange={(e) => setRecipient(e.target.value)}
                  required
                />
              </div>

              <div className="input-group">
                <label>Payment Method</label>
                <div className="payment-options">
                  <div className="payment-option active">
                    <div className="option-icon"><FiCreditCard /></div>
                    <div className="option-details">
                      <span>Credit Card</span>
                      <small>**** **** **** 1234</small>
                    </div>
                  </div>
                  <div className="payment-option">
                    <div className="option-icon"><MdAccountBalance /></div>
                    <div className="option-details">
                      <span>Bank Account</span>
                      <small>*** *** 4567</small>
                    </div>
                  </div>
                </div>
              </div>

              <button type="submit" className="submit-btn">
                Send Payment
              </button>
            </form>

            <div className="summary">
              <h3>Summary</h3>
              <div className="summary-row">
                <span>Amount</span>
                <span>${amount || '0.00'}</span>
              </div>
              <div className="summary-row">
                <span>Fee</span>
                <span>$0.00</span>
              </div>
              <div className="summary-row total">
                <span>Total</span>
                <span>${amount || '0.00'}</span>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'request' && (
          <div className="payment-card">
            <h2>Request Money</h2>
            <form>
              <div className="input-group">
                <label>Amount</label>
                <div className="amount-input">
                  <span className="currency">$</span>
                  <input
                    type="number"
                    placeholder="0.00"
                  />
                </div>
              </div>

              <div className="input-group">
                <label>From</label>
                <input
                  type="text"
                  placeholder="Email, phone number, or account ID"
                />
              </div>

              <button type="button" className="submit-btn">
                Request Money
              </button>
            </form>
          </div>
        )}

        {activeTab === 'history' && (
          <div className="payment-card">
            <h2>Transaction History</h2>
            
            <div className="filters">
              <select>
                <option>All Transactions</option>
                <option>Sent</option>
                <option>Received</option>
              </select>
              <select>
                <option>Last 30 Days</option>
                <option>Last 7 Days</option>
                <option>Last 90 Days</option>
              </select>
            </div>

            <div className="transactions">
              {transactions.map(transaction => (
                <div key={transaction.id} className="transaction">
                  <div className={`transaction-icon ${transaction.type}`}>
                    {transaction.type === 'sent' ? <FiArrowUp /> : <FiArrowDown />}
                  </div>
                  <div className="transaction-details">
                    <h4>{transaction.name}</h4>
                    <p>{transaction.date}</p>
                  </div>
                  <div className={`transaction-amount ${transaction.type}`}>
                    {transaction.type === 'sent' ? '-' : '+'}${transaction.amount.toFixed(2)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Payments;